<template>
  <div v-if="!redirecionando">
    <dashboard-fornecedor
      v-if="ehUsuarioFornecedor && canAccessDashFornecedor"
    />
    <dashboard-funcionario-varejo v-else/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { generateComputed } from '@/common/functions/roles-computed-generator';

import DashboardFuncionarioVarejo from '@/spa/dashboard/DashFuncionarioVarejo';
import DashboardFornecedor from '@/spa/dashboard/DashFornecedor';

export default {
  name: 'DashboardInicial',
  components: {
    DashboardFuncionarioVarejo,
    DashboardFornecedor,
  },
  data() {
    return {
      redirecionando: false,
    };
  },
  computed: {
    ...mapGetters('usuario', ['usuarioLogado']),
    ...generateComputed('ACESSO_FORNECEDOR', ['getAllRoles']),
    ...generateComputed('PAGE_DEFAULT_DEFINE', ['getAllRoles']),

    canAccessDashFornecedor() {
      return this.getAllRoles?.some((el) => el.startsWith('ACESSO_FORNECEDOR'));
    },

    ehUsuarioFornecedor() {
      return this.usuarioLogado?.tipo === 'FORNECEDOR';
    },

    rolePageDefaultDefine() {
      const role = this.getAllRoles?.find((el) => el.startsWith('PAGE_DEFAULT_DEFINE|'));
      if (!role) return null;

      const [, pageName] = role.split('|');
      return pageName || null;
    },
  },

  async created() {
    const jaRedirecionado = sessionStorage.getItem('redirecionado');

    if (!jaRedirecionado) {
      this.redirecionando = true;
      await this.verificarRedirecionamento();
      sessionStorage.setItem('redirecionado', 'true');
      this.redirecionando = false;
    }
  },

  methods: {
    async verificarRedirecionamento() {
      if (this.rolePageDefaultDefine) {
        const destino = this.rolePageDefaultDefine.trim();

        if (destino) {
          if (destino.startsWith('https') || destino.startsWith('/')) {
            window.location.href = destino;
          } else if (destino.includes('/')) {
            await this.$router.replace({ path: `/${destino}` });
          } else {
            await this.$router.replace({ name: destino });
          }
        }
      }
    },
  },
};
</script>
